import { AbstractRouterFilter } from '@zk/framework-vue';
import { Route } from 'vue-router';

const showPages: (string|RegExp)[] = [
  '/kanban/list',
  '/work/table',
  '/setting/fields',
  '/project/worktype',
  '/release',
  '/project/automation'
];

// 显示NPS定时器
let showTimer: number | undefined = undefined;

export default class NPSFilter extends AbstractRouterFilter {
  matches(): boolean {
    return (window as any).npsmeter && (window as any).npsmeter.open;
  }
  onBefore() {
    showTimer && clearTimeout(showTimer);
  }
  onAfter(): void;
  onAfter(to?: Route): void {
    if (!to) {
      return;
    }
    const isShowNPSPage = showPages.some(page => {
      if (page instanceof RegExp) {
        return page.test(to.fullPath || to.path);
      }
      return (to.fullPath || to.path).startsWith(page);
    });
    if (isShowNPSPage) {
      showTimer = window.setTimeout(() => {
        (window as any).npsmeter && (window as any).npsmeter.open();
      }, 20 * 1000);
    }
  }
}
